import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Skeleton, ArrowRightIcon } from '@ag1/ui';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { getPrice } from 'shared/utils/customer';
import { useStoreCurrency } from 'state/hooks/useStoreCurrency';
import { BaseImage } from 'types/studio/studio';
import { useUnfortunateWayToAppendCurrency } from '@portal/state/hooks/useUnfortunateWayToAppendCurrency';
import styles from './FirstStepInput.module.scss';

interface Props extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  title: string;
  description: string;
  price: string;
  img: BaseImage;
}

export const FirstStepInput = ({
  id,
  name,
  price,
  description,
  title,
  img,
  type,
  value,
  onChange,
  checked,
  defaultChecked
}: Props) => {
  const { symbolCurrency } = useStoreCurrency();
  const { t } = useTranslation('buildBundle');
  const { conditionallyAppendUSDtoPrice } = useUnfortunateWayToAppendCurrency();

  return (
    <label htmlFor={id} className={clsx(styles.card, checked && styles.cardChecked)}>
      <input
        id={id}
        type={type}
        name={name}
        value={value}
        className={styles.input}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <StudioBaseImageV2 image={img} className={styles.image} aspectRatio={0.75} />
      <div className={styles.checkmarkWrap}>
        <div className={styles.checkmark} />
      </div>

      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.price}>
          <span className={styles.priceText}>
            {t('firstStep.price')}{' '}
            {price ? (
              <span>{conditionallyAppendUSDtoPrice(getPrice(symbolCurrency, price, 0))}</span>
            ) : (
              <Skeleton className={styles.skeleton} />
            )}
          </span>
          <ArrowRightIcon className={styles.icon} />
        </p>
        <p className={styles.description}>{description}</p>
      </div>
    </label>
  );
};
